// PrintAgingReport.js
// Reusable print preview for Aging Summary Report
import { apiGetAgingReport } from "../../api/tunggakan";

function fmt2(v) {
  return Number(v || 0).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export async function printAgingReportPreview({ agingEnd, zon }) {
  if (!agingEnd) {
    throw new Error("Sila pilih Tarikh (Aging).");
  }

  const zonParam = zon === "SEMUA ZON" ? null : zon;
  const data = await apiGetAgingReport(zonParam, null, agingEnd);
  const rows = data.data || [];
  const totals = data.totals || {};

  const amountTotal = (
    Number(totals.aging_till6 || 0) +
    Number(totals.aging7_12 || 0) +
    Number(totals.aging13_18 || 0) +
    Number(totals.aging19_24 || 0) +
    Number(totals.aging25_30 || 0) +
    Number(totals.aging31_36 || 0) +
    Number(totals.aging37_72 || 0) +
    Number(totals.aging73_120 || 0) +
    Number(totals.aging_more120 || 0)
  );

  const runDate = new Date().toLocaleDateString("en-GB");
  const asAtDate = new Date(agingEnd).toLocaleDateString("en-GB");
  const logoUrl = window.location.origin + "/build/kejora.png";
  const orgName = "LEMBAGA KEMAJUAN JOHOR TENGGARA";
  const reportTitle = "(KEJORA)";

  const rowsHtml = rows
    .map((row, idx) => {
      const amount = (
        Number(row.aging_till6 || 0) +
        Number(row.aging7_12 || 0) +
        Number(row.aging13_18 || 0) +
        Number(row.aging19_24 || 0) +
        Number(row.aging25_30 || 0) +
        Number(row.aging31_36 || 0) +
        Number(row.aging37_72 || 0) +
        Number(row.aging73_120 || 0) +
        Number(row.aging_more120 || 0)
      );
      return `
        <tr>
          <td style="font-size: 0.5em; text-align: center;">${rows.length ? idx + 1 : ""}</td>
          <td style="font-size: 0.5em; text-align: center;">${row.no_akaun || ""}</td>
          <td style="font-size: 0.5em; text-align: left;">${row.nama || ""}</td>
          <td class="amount-col" style="font-size: 0.5em; font-weight: bold;">${fmt2(amount)}</td>
          <td class="aging-col" style="font-size: 0.5em;">${fmt2(row.aging_till6)}</td>
          <td class="aging-col" style="font-size: 0.5em;">${fmt2(row.aging7_12)}</td>
          <td class="aging-col" style="font-size: 0.5em;">${fmt2(row.aging13_18)}</td>
          <td class="aging-col" style="font-size: 0.5em;">${fmt2(row.aging19_24)}</td>
          <td class="aging-col" style="font-size: 0.5em;">${fmt2(row.aging25_30)}</td>
          <td class="aging-col" style="font-size: 0.5em;">${fmt2(row.aging31_36)}</td>
          <td class="aging-col" style="font-size: 0.5em;">${fmt2(row.aging37_72)}</td>
          <td class="aging-col" style="font-size: 0.5em;">${fmt2(row.aging73_120)}</td>
          <td class="aging-col" style="font-size: 0.5em;">${fmt2(row.aging_more120)}</td>
        </tr>`;
    })
    .join("");

  const html = `
    <html>
      <head>
        <title>Aging Summary Report</title>
        <style>
          @media print {
            @page { size: A4 landscape; margin: 20mm; }
            body { margin: 0; }
            .no-break { page-break-inside: avoid; page-break-before: avoid; }
          }
          body { font-family: Arial, sans-serif; margin: 20px; }
          .header-container { text-align: center; margin-bottom: 5px; }
          .logo { width: 60px; display: block; margin: 0 auto 8px auto; }
          .org-title { font-size: 1.1em; font-weight: bold; }
          .report-title { font-size: 1em; font-weight: bold; }
          .date-row { font-size: 0.95em; margin-bottom: 10px; text-align: left; }
          table { border-collapse: collapse; width: 100%; margin-top: 12px; }
          th, td { border: 1px solid #ccc; padding: 7px 8px; }
          th { background: #e9e9f6; color: #222; }
          td:first-child, th:first-child { text-align: left; }
          td:nth-child(2), th:nth-child(2) { text-align: left; }
          td:nth-child(3), th:nth-child(3) { text-align: center; }
          th.aging-col, td.aging-col { width: 6%; min-width: 20px; max-width: 90px; text-align: right; }
          th.amount-col, td.amount-col { min-width: 20px; text-align: right; }
          .jumlah-row td { font-weight: bold; background: #e3e3e3; }
        </style>
      </head>
      <body>
        <div class="header-container">
          <img src="${logoUrl}" class="logo" />
          <div class="org-title">${orgName}</div>
          <div class="report-title">${reportTitle}</div>
        </div>
        <div class="date-row" style="margin-bottom:10px; margin-top:50px;">Aging Summary Report as at ${asAtDate} (Run Date: ${runDate})</div>
        <table>
          <thead>
            <tr>
              <th style="font-size: 0.6em; font-weight: bold; text-align: center;">BIL</th>
              <th style="font-size: 0.6em; font-weight: bold; text-align: center;">NO AKAUN</th>
              <th style="font-size: 0.6em; font-weight: bold; text-align: center;">NAMA</th>
              <th class="amount-col" style="font-size: 0.6em; font-weight: bold; text-align: center;">AMOUNT (RM)</th>
              <th class="aging-col" style="font-size: 0.6em; font-weight: bold; text-align: center;">1-6</th>
              <th class="aging-col" style="font-size: 0.6em; font-weight: bold; text-align: center;">7-12</th>
              <th class="aging-col" style="font-size: 0.6em; font-weight: bold; text-align: center;">13-18</th>
              <th class="aging-col" style="font-size: 0.6em; font-weight: bold; text-align: center;">19-24</th>
              <th class="aging-col" style="font-size: 0.6em; font-weight: bold; text-align: center;">25-30</th>
              <th class="aging-col" style="font-size: 0.6em; font-weight: bold; text-align: center;">31-36</th>
              <th class="aging-col" style="font-size: 0.6em; font-weight: bold; text-align: center;">37-72</th>
              <th class="aging-col" style="font-size: 0.6em; font-weight: bold; text-align: center;">73-120</th>
              <th class="aging-col" style="font-size: 0.6em; font-weight: bold; text-align: center;">&gt;120</th>
            </tr>
          </thead>
          <tbody>
            ${rowsHtml}
          </tbody>
          <tr class="jumlah-row no-break">
            <td style="font-size: 0.7em; font-weight: bold; text-align: center;" colspan="3">JUMLAH (RM)</td>
            <td class="amount-col" style="font-size: 0.7em;">${fmt2(amountTotal)}</td>
            <td class="aging-col" style="font-size: 0.7em;">${fmt2(totals.aging_till6)}</td>
            <td class="aging-col" style="font-size: 0.7em;">${fmt2(totals.aging7_12)}</td>
            <td class="aging-col" style="font-size: 0.7em;">${fmt2(totals.aging13_18)}</td>
            <td class="aging-col" style="font-size: 0.7em;">${fmt2(totals.aging19_24)}</td>
            <td class="aging-col" style="font-size: 0.7em;">${fmt2(totals.aging25_30)}</td>
            <td class="aging-col" style="font-size: 0.7em;">${fmt2(totals.aging31_36)}</td>
            <td class="aging-col" style="font-size: 0.7em;">${fmt2(totals.aging37_72)}</td>
            <td class="aging-col" style="font-size: 0.7em;">${fmt2(totals.aging73_120)}</td>
            <td class="aging-col" style="font-size: 0.7em;">${fmt2(totals.aging_more120)}</td>
          </tr>
        </table>
        <script>
          function imagesLoaded(doc, callback) {
            var imgs = doc.images;
            if (!imgs || imgs.length === 0) return callback();
            var loaded = 0;
            var check = function() { if (++loaded >= imgs.length) callback(); };
            for (var i = 0; i < imgs.length; i++) {
              if (imgs[i].complete) check();
              else imgs[i].addEventListener('load', check, false);
              imgs[i].addEventListener('error', check, false);
            }
          }
          imagesLoaded(document, function() { window.print(); });
        </script>
      </body>
    </html>`;

  const win = window.open("", "_blank");
  win.document.open();
  win.document.write(html);
  win.document.close();
}

export default printAgingReportPreview;
